import { Button } from "@mui/material";

type LogInButtonProps = {
	disabled?: boolean;
	isLoading?: boolean;
	isSingleRole?: boolean;
	isLoggedIn?: boolean;
	onClick: () => void;
	onLogout?: () => void;
};
export default function LogInButton(props: Readonly<LogInButtonProps>) {
	const { isLoggedIn = false, disabled = false, isLoading = false } = props;
	return (
		<Button
			variant={"contained"}
			disabled={disabled || isLoading}
			classes={{
				root: `!bg-[#2357BE] !font-sans !font-normal !text-sm !rounded-[6px] !capitalize !h-[30px] !shadow-none !w-[82px] ${
					isLoggedIn ? "!bg-[#585B6D]" : ""
				}`,
				disabled: "!bg-[#CCCCCC] !text-white",
			}}
			onClick={props.onClick}
		>
			{`Log ${isLoggedIn ? "out" : "in"}`}
		</Button>
	);
}
